import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import sidebarHelper from "../../../helpers/sidebar";

export default function ReportPositionMenu({ activeItem }) {
  return (
    <li className="nav-item">
      <Link
        to="/positions/report-position"
        className={`nav-link  d-flex
        ${sidebarHelper.checkActiveItem(activeItem, "report-position")} `}
      >
        <i class="fa-solid fa-magnifying-glass-chart pl-2" size="14"></i>
        <p>گزارش جایگاه های تبلیغاتی</p>
      </Link>
    </li>
  );
}
